import { Component, ErrorInfo, ReactNode } from "react";

export class ErrorBoundary extends Component<{
    children: ReactNode;
    fallback: (error: Error, reset: () => void) => ReactNode;
}, { error: Error | null }> {

    state: { error: Error | null } = { error: null };

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error(error, info);
    }

    render() {
        if (this.state.error) {
            return this.props.fallback(this.state.error, () => this.setState({ error: null }));
        }

        return this.props.children;
    }
}
